import * as React from 'react';
import {colors} from "../../ui-components";

const SvgQuote = props => {
  const { fill = colors.crederaRed, alt } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="164" height="121" viewBox="0 0 164 121" fill="none" alt={alt}>
      <path d="M118.57 52.7489H135.648C150.927 55.955 162.612 66.4894 162.612 85.726C162.612 106.795 146.883 120.535 126.659 120.535C102.391 120.535 87.5606 100.841 87.5606 72.9016C87.5606 31.2222 114.076 3.74128 163.511 0.535156V15.6497C136.546 19.3138 120.817 30.7642 118.57 52.7489ZM31.3843 52.7489H48.9113C63.7419 55.955 75.4265 66.4894 75.4265 85.726C75.4265 106.795 59.6972 120.535 39.4737 120.535C15.2055 120.535 0.375 100.841 0.375 72.9016C0.375 31.2222 27.3396 3.74128 76.7748 0.535156V15.6497C49.8101 19.3138 33.6314 30.7642 31.3843 52.7489Z" fill={fill}/>
    </svg>
  );
};

export default SvgQuote;
